module.exports = __webpack_public_path__ + "static/media/saphnelo-dosage-rtm-a360-logo.d327d149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saphnelo-dosage-rtm-a360-logo.png
// module id = 1368
// module chunks = 0